<template>
  <a @click="modal" class="pointer position-relative btn btn-plain">
    <TaskSvg/>
    <span class="d-none d-xl-inline header-title">{{ $t('tasks') }}</span>
    <TasksModal v-if="show"/>
    <TaskShowModal/>
    <span class="notification-bubble" v-if="tasksCounter > 0">
      {{ tasksCounter }}
    </span>
  </a>
</template>

<script setup>

import TaskSvg from '@/assets/svg-vue/header/note.svg'
import TasksModal from "@/components/parts/header/TasksModal"
import { useStore} from "vuex"
import {ref, computed, nextTick, onBeforeMount, getCurrentInstance} from "vue"
import TaskShowModal from "@/components/parts/crm/TaskShowModal"

const store = useStore()

let bvModal = null

const show = ref(false)

const headerCounters = computed(() => store.state.auth.headerCounters || {})
const tasksCounter = computed(() => headerCounters.value.tasks || 0)

onBeforeMount(() => {
  const instance = (getCurrentInstance())
  bvModal = instance?.proxy?.$bvModal
})

const modal = async () => {
  show.value = true
  await nextTick()
  bvModal.show('tasks-modal')
}
</script>

<style scoped>
.notification-bubble {
  top: 0;
  left: 8px;
}
</style>
